import React from 'react';
import style from './style.scss'; //NOSONAR

const ShelfProductLoader = () => {

    return (
        <div className="shelf-product-loading">
            <span className="shelf-product-loading-img"></span>
            <span className="shelf-product-loading-box"></span>
            <span className="shelf-product-loading-box"></span>
            <span className="shelf-product-loading-button"> </span>
        </div>
    );
};

export default ShelfProductLoader;
